class NewsletterPopup extends HTMLElement {
    constructor() {
        super();

        this.popup = this;
        this.expiresDate = this.popup.getAttribute('data-expire') || 90;
        this.hasShown = false;
        this.postScrollDelay = 30000;
        this.scrollThreshold = 0.6;

        if (this.getCookie('newsletter-popup') === '' && !this.isCartPage()) {
            this.boundScroll = this.onScrollCheck.bind(this);
            this.boundExitIntent = this.onExitIntent.bind(this);

            window.addEventListener('scroll', this.boundScroll, { passive: true });

            if (window.matchMedia('(min-width: 768px)').matches && window.matchMedia('(hover: hover)').matches) {
                document.addEventListener('mouseout', this.boundExitIntent);
            }
        }
        
        document.body.addEventListener('click', this.onBodyClickEvent.bind(this));

        this.querySelector('[data-close-newsletter-popup]').addEventListener(
            'click',
            this.setClosePopup.bind(this)
        );

        this.querySelector('#ContactPopup').addEventListener(
            'submit',
            this.setClosePopup.bind(this)
        );
    }

    isCartPage() {
        return /\/cart(\/|$)/.test(window.location.pathname);
    }

    onScrollCheck() {
        if (this.scrollTimer) return;
        if (window.scrollY > window.innerHeight * this.scrollThreshold) {
            window.removeEventListener('scroll', this.boundScroll);
            this.scrollTimer = setTimeout(this.showPopup.bind(this), this.postScrollDelay);
        }
    }

    onExitIntent(event) {
        if (event.clientY <= 0 && !event.relatedTarget) {
            this.showPopup();
        }
    }

    clearTriggers() {
        if (this.boundScroll) window.removeEventListener('scroll', this.boundScroll);
        if (this.boundExitIntent) document.removeEventListener('mouseout', this.boundExitIntent);
        if (this.scrollTimer) clearTimeout(this.scrollTimer);
    }

    showPopup() {
        if (this.hasShown) return;
        this.hasShown = true;
        this.clearTriggers();
        this.setCookie('newsletter-popup', 'shown', this.expiresDate);
        document.body.classList.add('newsletter-show');
        setTimeout(() => {
            document.body.classList.add('show-newsletter-image');
        }, 700);
    }

    setCookie(cname, cvalue, exdays) {
        const d = new Date();
        d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
        const expires = 'expires=' + d.toUTCString();
        document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/';
    }

    getCookie(cname) {
        const name = cname + '=';
        const ca = document.cookie.split(';');

        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) === ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) === 0) {
                return c.substring(name.length, c.length);
            }
        }

        return '';
    }

    deleteCookie(name) {
        document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:01 GMT;';
    }

    setClosePopup() {
        this.hasShown = true;
        this.clearTriggers();
        this.setCookie('newsletter-popup', 'closed', this.expiresDate);
        document.body.classList.remove('newsletter-show');
        setTimeout(() => {
            document.body.classList.remove('show-newsletter-image');
        }, 700)
    }

    onBodyClickEvent(event){
        if ((!this.contains(event.target)) && ($(event.target).closest('[data-open-newsletter-popup]').length === 0) && document.querySelector('body').classList.contains('newsletter-show')){
            this.setClosePopup();
        }
    }
}

customElements.define('newsletter-popup', NewsletterPopup);

class NewsletterMessagePopup extends HTMLElement {
    constructor() {
        super();

        this.querySelector('[data-close-newsletter-message-popup]').addEventListener(
            'click',
            this.close.bind(this)
        );

        document.body.addEventListener('click', this.onBodyClickEvent.bind(this));
    }

    close(){
        document.body.classList.remove('newsletter-message-show');
    }

    onBodyClickEvent(event){
        if (!this.contains(event.target)){
            this.close();
        }
    }
}

customElements.define('newsletter-message-popup', NewsletterMessagePopup);